/** @jsxImportSource @emotion/react */

import tw from "twin.macro";

export const NotFoundIllustration = (props) => {
  return (
    <svg viewBox="0 0 1121 778" {...props}>
      <circle cx="212.6" cy="103" r="64" tw="fill-current text-primary-400" />
      <path
        tw="fill-current text-primary-300"
        d="M524 343c0 151-90 204-201 204s-200-53-200-204S323 0 323 0s201 192 201 343z"
      />
      <path
        tw="fill-current text-gray-700"
        d="M316 524l2-127 86-156-85 137v-57l59-113-58 98 1-103 63-90-62 74 1-187-7 248 1-10-64-98 63 118-6 114-1-3-73-104 73 114v15h-1v1l-15 290h21l2-150 73-114-73 103z"
      />
      <path
        tw="fill-current text-primary-300"
        d="M1121 405c0 124-74 167-165 167s-164-43-164-167 164-281 164-281 165 157 165 281z"
      />
      <path
        tw="fill-current text-gray-700"
        d="M950 553l2-104 70-128-70 112 1-46 48-93-48 80 2-83 51-74-51 61 1-154-6 203 1-8-53-81 52 97-5 93v-2l-60-85 60 94-1 11v1l-12 237h16l2-122 61-93-61 84z"
      />
      <ellipse cx="554.6" cy="680.5" tw="fill-current text-gray-700" rx="554.6" ry="28" />
      <ellipse cx="892.4" cy="726.8" tw="fill-current text-gray-700" rx="95" ry="4.8" />
      <ellipse cx="548.7" cy="773.1" tw="fill-current text-gray-700" rx="95" ry="4.8" />
      <ellipse cx="287.9" cy="734.3" tw="fill-current text-gray-700" rx="217" ry="11" />
      <circle cx="97.1" cy="566.3" r="79" tw="fill-current text-gray-800" />
      <path tw="fill-current text-gray-800" d="M61 628h24l-1 43H60zM109 629h24l-1 43h-24z" />
      <ellipse
        cx="119.5"
        cy="732.6"
        tw="fill-current text-gray-800"
        rx="7.5"
        ry="20"
        transform="rotate(-89 69 722)"
      />
      <ellipse
        cx="167.6"
        cy="732.2"
        tw="fill-current text-gray-800"
        rx="7.5"
        ry="20"
        transform="rotate(-89 117 722)"
      />
      <circle cx="99.3" cy="546.3" r="27" tw="fill-current text-white" />
      <circle cx="99.3" cy="546.3" r="9" tw="fill-current text-gray-700" />
      <path
        tw="fill-current text-primary-500"
        d="M21 492c-6-29 15-57 47-64s62 11 68 40-15 39-47 45-62 8-68-21z"
      />
      <path
        tw="fill-current text-primary-500"
        d="M218 610c0 55-33 75-74 75h-2l-6-1c-36-2-65-22-65-74 0-53 68-120 73-125s74 70 74 125z"
      />
      <path
        tw="fill-current text-gray-700"
        d="M142 676l27-37-27 41v5l-6-1 3-55v-5l-27-42 27 38v1l3-42-23-43 23 36 2-87v69l23-27-23 32-1 38 21-36-21 41v21l31-50-31 57z"
      />
      <circle cx="712.5" cy="565.4" r="79" tw="fill-current text-gray-800" />
      <path
        tw="fill-current text-gray-800"
        d="M697 635l22-7 13 41-23 7zM743 621l23-7 12 41-23 7z"
      />
      <ellipse
        cx="767.9"
        cy="732"
        tw="fill-current text-gray-800"
        rx="20"
        ry="7.5"
        transform="rotate(-17 545 834)"
      />
      <ellipse
        cx="813.5"
        cy="716.9"
        tw="fill-current text-gray-800"
        rx="20"
        ry="7.5"
        transform="rotate(-17 590 819)"
      />
      <circle cx="708.5" cy="545.7" r="27" tw="fill-current text-white" />
      <circle cx="708.5" cy="545.7" r="9" tw="fill-current text-gray-700" />
      <path
        tw="fill-current text-primary-500"
        d="M618 518c-15-26-4-59 24-75s63-9 77 17-2 41-30 57-57 26-71 1zM572 600c0 51-30 68-68 68h-7c-34-2-60-21-60-68 0-48 63-110 67-114v-1s68 65 68 115z"
      />
      <path
        tw="fill-current text-gray-700"
        d="M502 661l25-35-25 38v4h-5l2-50v-1l1-5-25-38 25 35v1l2-38-21-40 21 33 2-79v-1 63l21-25-21 31-1 34 20-33-20 38v19l28-46-28 52z"
      />
      <path
        tw="fill-current text-primary-500"
        d="M836 621c0 55-33 75-74 75h-2l-6-1c-36-2-65-22-65-74 0-53 68-120 73-125s74 70 74 125z"
      />
      <path
        tw="fill-current text-gray-700"
        d="M760 687l27-37-27 41v5l-6-1 3-55v-5l-27-42 27 38v1l3-42-23-43 23 36 2-87v69l23-27-23 32-1 38 21-36-21 41v21l31-50-31 57z"
      />
      <ellipse
        cx="721.5"
        cy="656.8"
        tw="fill-current text-gray-800"
        rx="12.4"
        ry="39.5"
        transform="rotate(-65 653 658)"
      />
      <ellipse
        cx="112.5"
        cy="651.8"
        tw="fill-current text-gray-800"
        rx="12.4"
        ry="39.5"
        transform="rotate(-68 48 651)"
      />
    </svg>
  );
};
